import { render, staticRenderFns } from "./onboardStatus.vue?vue&type=template&id=d1026374"
import script from "./onboardStatus.vue?vue&type=script&lang=js"
export * from "./onboardStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports